export const SubscriptionStatusEnum = {
    Active : 1,
    Cancel : 2,
    Pause : 3
}